import styled, { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import Default from "./assets/images/Default.svg";
import Basier from './assets/fonts/basiercircle-regular-webfont.ttf'
import BasierEot from './assets/fonts/basiercircle-regular-webfont.eot'
import BasierWoff from './assets/fonts/basiercircle-regular-webfont.woff'
import BasierSemi from './assets/fonts/basiercircle-semibold-webfont.ttf'

export const formBreakpoint = '768px'

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 31, 68, 0.5);
  z-index: var(--open-routes-overlay-z-index);
`

const GlobalStyles = createGlobalStyle`
  ${reset}

  :root {
    --dark:#000000;
    --light:#ffffff;
    --grey-900: #7A8797;
    --grey-500: #C9CED6;
    --grey-400: #E1E4E8;
    --grey-300: #F1F2F4;
    --grey-200: #F7F8F9;
    --grey-100: #FAFBFB;
    --white-100: #F9F9F9;
    --brand-800: #026DD6;
    --brand-700: #0284FE;
    --brand-600: #4BA7FE;
    --brand-400: #B3DAFF;
    --brand-200: #EEF7FF;
    --warning:#f07300;
    --warning-700: #FFAD0D;
    --text-dark:#1d232e;
    --text-medium:#4A5463;
    --text-light:#7A8797;
    --text-disabled:#B8BDC5;
    --shadow:rgba(0, 0, 0, 0.1);
    --form-z-index: 1600;
    --search-overlay-z-index: 1599;
    --routes-z-index: 1500;
    --flights-z-index: 1700;
    --modal-z-index: 2000;
  }

  @font-face {
    font-family: 'Basier';
    font-style: normal;
    font-weight: 400;
    src: local('☺'), url(${BasierEot}), url(${Basier}) format('truetype'), url(${BasierWoff}) format('woff');
  }

  @font-face {
    font-family: 'Basier';
    font-style: normal;
    font-weight: 600;
    src: local('☺'), url(${BasierSemi});
  }

  *,*::before,*::after {
    box-sizing: border-box;
  }

  html {
    font-size:10px;
  }

  body {
    color: var(--dark);
    font-size: 1.4rem;
    font-family: Basier, Arial, sans-serif;
    line-height: 1.2;
    cursor: url(${Default}), auto;

    @media (max-width: ${formBreakpoint}) {
      font-size: 1.6rem;
      font-weight: 500;
    }
  }

  input {
    padding: 0;

    &::placeholder {
      color: var(--text-disabled);
    }

    &:read-only:focus::placeholder {
      color: var(--text-dark);
    }

    &::-ms-clear {
      display: none;
    }

    &:-moz-focus-inner {
      padding: $moz-focus-inner-padding;
      border: none;
    }
  }
`;

export default GlobalStyles
